import { packagingComponentBaseSchema } from "../packaging-solution/packaging-component/packaging-component-base";

import { mediaSavedSchema } from "./media-saved";

export const packagingComponentBaseSavedSchema = packagingComponentBaseSchema.extend({
	media: mediaSavedSchema,
});
